import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Col, Container, Row} from '@modifi/ui'

import Link from '../../features/common/link'
import {ctaMapping} from '../constants'

const propTypes = {
  horizontalAlignment: PropTypes.oneOf(['left', 'right', 'center']),
  ctaType: PropTypes.oneOf(['primary', 'secondary', 'link']),
  scrollToComponentIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  externalLink: PropTypes.string,
  innerText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}
const defaultProps = {
  horizontalAlignment: 'center',
  ctaType: 'primary',
  scrollToComponentIndex: undefined,
  externalLink: undefined,
  innerText: '',
}

export type ButtonProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const Button: React.FC<ButtonProps> = ({
  horizontalAlignment,
  ctaType,
  scrollToComponentIndex,
  externalLink,
  innerText,
  onClick,
}) => {
  const MyButton = ctaMapping[ctaType || 'primary']

  let buttonAligment = 'center'
  if (horizontalAlignment === 'left') buttonAligment = 'start'
  if (horizontalAlignment === 'right') buttonAligment = 'end'

  if (scrollToComponentIndex !== undefined && scrollToComponentIndex !== '') {
    return (
      <Container>
        <Row justifyContent={buttonAligment}>
          <Col col="auto" style={{width: 'fit-content'}}>
            <MyButton data-target={`jump-to-component-${scrollToComponentIndex}`} onClick={onClick}>
              {innerText}
            </MyButton>
          </Col>
        </Row>
      </Container>
    )
  }

  return (
    <Container>
      <Row justifyContent={buttonAligment}>
        <Col col="auto" style={{width: 'fit-content'}}>
          <Link type="button" buttonComponent={MyButton} to={externalLink} isExternal targetBlank>
            {innerText || ''}
          </Link>
        </Col>
      </Row>
    </Container>
  )
}

Button.propTypes = propTypes

Button.defaultProps = defaultProps

export default Button
